import script from "./PhoneType.vue?vue&type=script&lang=js"
export * from "./PhoneType.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__